
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LeagueHeader from './components/LeagueHeader';
import ScoreboardSection from './components/ScoreboardSection';

export default function WinterLeague() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <LeagueHeader />
        <ScoreboardSection />
      </main>
      <Footer />
    </div>
  );
}
